import { takeLatest, call, put } from "redux-saga/effects";
import {
  REGION_EMAIL_ADD_REQUEST,
  regionEmailAdded,
  regionEmailAddError,
} from "../../actions/regions";
import addEmail from "../../../../../backend/oncall/partners/regions/emails/add";

const requestAddEmail = function*(action) {
  try {
    yield call(addEmail, action.payload.regionId, action.payload.email);
    yield put(regionEmailAdded(action.payload.email));
  } catch (error) {
    yield put(regionEmailAddError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(REGION_EMAIL_ADD_REQUEST, requestAddEmail);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/regions/request-add-email.js